import React from "react";

import "./WeeklyChart.css";

function WeeklyChart({ data = [] }) {

    const dayNames = [

        "",

        "Sun",

        "Mon",

        "Tue",

        "Wed",

        "Thu",

        "Fri",

        "Sat"

    ];

    const weeklyData = dayNames
        .slice(1)
        .map((day, index) => {

            const found = data.find(

                (item) =>

                    item._id.day === index + 2 ||

                    (index === 6 && item._id.day === 1)

            );

            return {

                day,

                amount: found?.earnings || 0,

                orders: found?.orders || 0,

            };

        });

    const max = Math.max(

        ...weeklyData.map(

            (item) => item.amount

        ),

        1

    );

    const total = weeklyData.reduce(

        (sum, item) =>

            sum + item.amount,

        0

    );

    return (

        <div className="weekly-chart-card">

            <div className="weekly-header">

                <div>

                    <h2>

                        Weekly Earnings

                    </h2>

                    <p>

                        Total ₹{total}

                    </p>

                </div>

            </div>

            <div className="weekly-bars">

                {

                    weeklyData.map((item) => (

                        <div

                            key={item.day}

                            className="bar-item"

                        >

                            <span className="amount">

                                ₹{item.amount}

                            </span>

                            <div

                                className="bar"

                                style={{

                                    height:

                                        `${(item.amount / max) * 160}px`

                                }}

                            />

                            <span className="day">

                                {item.day}

                            </span>

                        </div>

                    ))

                }

            </div>

        </div>

    );

}

export default WeeklyChart;